import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { CharlieConfirmProvider } from '@ver.id/libs.ui.charlie';
import { apolloClient } from './apollo';
import App from './App';
import { I18nProvider } from './i18n/i18n';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { reportCrashToParent } from './hooks/useParentMessaging';
import { leaveAfterCrash } from './hooks/useEmbeddedHost';
import { isInIframe } from './utils/iframe';
import '@fontsource-variable/inter';
import './index.css';

/** Embedded Ronan crashed outside its card or drawer (the shell, a provider, the flow's hooks). */
function onCrash() {
  if (!isInIframe()) return;
  reportCrashToParent();
  leaveAfterCrash();
}

const root = document.getElementById('root');
if (!root) throw new Error('Ronan: no #root element to mount in.');

createRoot(root).render(
  <ApolloProvider client={apolloClient}>
    <I18nProvider>
      <ErrorBoundary onError={onCrash}>
        <CharlieConfirmProvider>
          <App />
        </CharlieConfirmProvider>
      </ErrorBoundary>
    </I18nProvider>
  </ApolloProvider>,
);
